import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL || 'https://edtuatbackend.onehublink.com/api';

export default axios.create({
  baseURL: apiURL
});

export const axiosPrivate = axios.create({
  baseURL: apiURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});
